import { useAuth0 } from '@auth0/auth0-react'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../types'
import { getFeatureFlags } from './featureFlags'
import { FeatureFlags } from './types'

export const useGetFeatureFlagsQuery = ({
  enabled = true,
}: {
  enabled?: boolean
} = {}): UseQueryResult<FeatureFlags, Error> => {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: [QueryKeys.FeatureFlags, 'private'],
    queryFn: async (): Promise<FeatureFlags> => {
      const accessToken = await getAccessTokenSilently()
      return await getFeatureFlags({ accessToken })
    },
    enabled,
  })
}
